import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    zIndex: theme.zIndex.drawer - 1,
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity 0.3s ease',
  },
  overlayVisible: {
    opacity: 1,
    pointerEvents: 'auto',
  },
  panel: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    width: '75%',
    maxWidth: '75%',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[8],
    zIndex: theme.zIndex.drawer,
    overflowY: 'auto',
    transform: 'translateX(100%)',
    transition: 'transform 0.3s ease',
  },
  panelVisible: {
    transform: 'translateX(0)',
  },
  content: {
    padding: theme.spacing(2),
    height: '100%',
  },
}));
